import React, { useState, useEffect, useMemo, useCallback, memo } from 'react';
import EmptySection from 'components/lib/EmptySection';
import Accordion from 'components/lib/Accordion';
import Carousel from 'components/lib/Carousel';
import FlipCard from 'components/lib/FlipCard';
import FullPageText from 'components/lib/FullPageText';
import Multichoice from 'components/lib/Multichoice';
import Sortation from 'components/lib/Sortation';
import Matching from 'components/lib/Matching';
import TextAndImage from 'components/lib/TextAndImage';
import HotSpot from 'components/lib/HotSpot';
import FiveStarRating from 'components/lib/FiveStarRating';
import ResultsPage from 'components/lib/ResultsPage';
import ClickAndReveal from 'components/lib/ClickAndReveal';
import TopicPortal from 'components/lib/TopicPortal';

const InteractionComponents = {
  Accordion,
  Carousel,
  FlipCard,
  FullPageText,
  Multichoice,
  Sortation,
  Matching,
  TextAndImage,
  HotSpot,
  FiveStarRating,
  ResultsPage,
  ClickAndReveal,
  TopicPortal,
};

const Interactions_Editor = ({
  currentTopicId,
  currentInteractionId,
  interactions,
}) => {
  if (!interactions.length) {
    return <EmptySection />;
  }

  const interaction = interactions.find(
    (i: any) => i.id === (currentInteractionId || interactions[0].id)
  );

  if (!interaction) {
    return null;
  }

  const Interaction = InteractionComponents[interaction?.meta?.subType];

  // console.log(`renders : ${interaction.props.name}`);

  return (
    <Interaction
      key={interaction.id}
      blockId={interaction.id}
      isOpen={true}
      aria-label={`Interaction: ${interaction.props.name}`}
      data={{
        ...interaction,
      }}
    />
  );
};

export default Interactions_Editor;
